import React from "react";
import { fmtL100 } from "./monthUtils";

const Cell = ({ label, value, tone = "", testId }) => (
  <div className={`border-2 px-3 py-2 ${tone || "border-zinc-200 bg-white"}`} data-testid={testId}>
    <div className="text-[9px] uppercase tracking-widest font-bold opacity-70">{label}</div>
    <div className="mono text-lg font-bold leading-tight">{value}</div>
  </div>
);

export const MonthSummary = ({ summary, threshold }) => {
  if (!summary) return null;
  const avg = summary.avg_l_per_100;
  const avgTone = avg == null ? "" : avg > threshold ? "border-red-600 bg-red-50 text-red-700" : "border-emerald-600 bg-emerald-50 text-emerald-800";
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2 mb-4" data-testid="fuel-month-summary">
      <Cell label="Pleins" value={summary.count} testId="fuel-sum-count" />
      <Cell label="Litres" value={summary.liters.toLocaleString("fr-FR")} testId="fuel-sum-liters" />
      <Cell label="Montant" value={`${summary.amount_eur.toLocaleString("fr-FR", { maximumFractionDigits: 0 })} €`} testId="fuel-sum-amount" />
      <Cell label="Km parcourus" value={summary.km.toLocaleString("fr-FR")} testId="fuel-sum-km" />
      <Cell label="Moyenne" value={fmtL100(avg)} tone={avgTone} testId="fuel-sum-avg" />
      <Cell label="Surconso" value={summary.over_count} tone={summary.over_count ? "border-red-600 bg-red-600 text-white" : ""} testId="fuel-sum-over" />
      <Cell label="Aberrants exclus" value={summary.aberrant_count} tone={summary.aberrant_count ? "border-zinc-500 bg-zinc-100" : ""} testId="fuel-sum-aberrant" />
    </div>
  );
};
